const configurationConstants = {};

configurationConstants.GET_CONFIGURATION = "users/getcongfiguration";

configurationConstants.GET_CLIENTS = "users/client/:ID";

configurationConstants.GET_LOCATIONS = "users/location/:ID";

configurationConstants.SAVE_CONFIGURATION = "users/addcongfiguration";

configurationConstants.SAVE_LOCATION = "users/display/addLocation/:ID";

configurationConstants.SAVE_CHART_LIST_SETTINGS =
  "users/chart-list-settings/:ID";

configurationConstants.ADD_AUDIT_AREA = "users/configuration/feedback-categories";
configurationConstants.GET_NEW_AUDIT_INFO = "/audit-info";

//form constants

configurationConstants.LOCATION_CONFIGURATION = "LOCATION_CONFIGURATION";
configurationConstants.LOCATION_DATA = "locations";

configurationConstants.GENERAL_CONFIGURATION = "GENERAL_CONFIGURATION";
configurationConstants.PROCESS_DATA = "processes";
configurationConstants.DOES_SUPPORT_PROCESS_WISE_CODING = "process_wise_coding";
configurationConstants.SPECIALITY_DATA = "specialties";
configurationConstants.SUB_SPECIALITY = "subspecialties";
configurationConstants.FACILITY = "facility";

configurationConstants.FEEDBACK_CONFIGURATION = "FEEDBACK_CONFIGURATION";
configurationConstants.PRIMARY_DIAGNOSIS = "primfeed";
configurationConstants.SECONDARY_DIAGNOSIS = "sec_diag_feed";
configurationConstants.PROCEDURES = "procedure_feed";
configurationConstants.EDM_LEVEL = "ed_em_feed";
configurationConstants.MODIFIER = "modifier_feed";
configurationConstants.POA = "poa_feed";
configurationConstants.DRUG = "drug_feed";

configurationConstants.AUDITING_CONFIGURATION = "AUDITING_CONFIGURATION";
configurationConstants.AUDIT_OPTIONS = "auditorOption";
configurationConstants.FEEDBACK_TYPES = "feedback_types";
configurationConstants.CODING_CONFIGURATION = "CODING_CONFIGURATION";
configurationConstants.CHART_FIELD_CONFIGURATION = "CHART_FIELD_CONFIGURATION";
configurationConstants.HOLD_REASON = "hold_reasons";
configurationConstants.RESPONSIBLE_PARTIES = "responsible_parties";
configurationConstants.DISPOSITION = "dispositions";
configurationConstants.PRIMARY_HEALTH = "primary_health";

configurationConstants.CHART_INFO_FIELDS = 'users/configurations/chart-custom-fields';
configurationConstants.HCC_FIELDS = 'users/configurations/hcc-fields';

configurationConstants.DEFAULT_FEEDBACK_CATEGORIES = 'users/configuration/feedback-category/master-data'
configurationConstants.FEEDBACK_CATEGORY_COPY = 'users/configuration/feedback-categories/copy'

export default configurationConstants;
